import { FormTimeInputProps } from '../../types/DateInput';
import Style from './panelStyles.module.scss';
import { useNode } from '@craftjs/core';
import { PanelContainer } from './uiKit/panelContainer/panelContainer';
import { ControlsGroup } from './uiKit/controlsGroup/controlsGroup';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { SettingsInput } from './uiKit/input/settingsInput';

export const TimeFieldPanel = () => {
  const { t } = useScopedTranslation('GeneralFormBuilder.Panels.TimeField');
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props as FormTimeInputProps,
  }));

  return (
    <PanelContainer header={t('Header')} panelName="General">
      <ControlsGroup
        header={t('Placeholder')}
        collapsible={true}
        contentClassName={Style.flexContainer}
        expanded={!!props.placeholder}
        onOpen={() => {
          setProp((prop: FormTimeInputProps) => {
            prop.placeholder = t('Placeholder');
          }, 500);
        }}
        onClose={() => {
          setProp((prop: FormTimeInputProps) => {
            prop.placeholder = undefined;
          }, 500);
        }}
      >
        <SettingsInput
          placeholder={t('PlaceholderPlaceholder')}
          multiple={true}
          value={props.placeholder}
          onChange={(e) =>
            setProp((p: FormTimeInputProps) => {
              p.placeholder = e.target.value || undefined;
            }, 500)
          }
        />
      </ControlsGroup>
      <ControlsGroup header={t('TimeInterval')} contentClassName={Style.flexContainer}>
        <SettingsInput
          placeholder={t('TimeIntervalPlaceholder')}
          value={props.timeIntervalInMinutes}
          onChange={(e) =>
            setProp((p: FormTimeInputProps) => {
              p.timeIntervalInMinutes = +e.target.value || undefined;
            }, 500)
          }
          units={t('TimeIntervalUnits')}
        />
      </ControlsGroup>
    </PanelContainer>
  );
};
